/**
 * @file pricing.js
 * @description Pricing data for Metro Plumbing & Heating services
 */

export const pricingData = {
  standard: [
    {
      service: 'Plumbing',
      price: '£80',
      description: 'Standard plumbing services',
      zone1Addition: '+£30'
    },
    {
      service: 'Gas',
      price: '£90',
      description: 'Gas installation and repair',
      zone1Addition: '+£30'
    }
  ],
  evening: [
    {
      service: 'Evening Plumbing (6pm-10pm)',
      price: '£100',
      description: 'Evening plumbing services',
      zone1Addition: '+£30'
    },
    {
      service: 'Evening Gas (6pm-10pm)',
      price: '£110',
      description: 'Evening gas services',
      zone1Addition: '+£30'
    }
  ],
  weekend: [
    {
      service: 'Weekend Plumbing',
      price: '£100',
      description: 'Saturday plumbing services',
      zone1Addition: '+£30'
    },
    {
      service: 'Weekend Gas',
      price: '£110',
      description: 'Saturday gas services',
      zone1Addition: '+£30'
    },
    {
      service: 'Sunday',
      price: '£130',
      description: 'Sunday services (all types)',
      zone1Addition: '+£30'
    }
  ],
  emergency: [
    {
      service: 'Night Emergency (10pm-7am)',
      price: '£150',
      description: '24/7 emergency services',
      zone1Addition: '+£30'
    },
    {
      service: 'Blocked Sink',
      price: '£100',
      description: 'Blocked sink clearance',
      zone1Addition: '+£30'
    }
  ]
};

export const allServices = [
  'Plumbing Repairs & Installation',
  'Gas Boiler Installation',
  'Central Heating Systems',
  'Boiler Servicing & Repairs',
  'Bathroom Installation',
  'Kitchen Plumbing',
  'Emergency Plumbing',
  'Drainage & Blocked Drains',
  'Leak Detection & Repair',
  'Radiator Installation',
  'Power Flushing',
  'Gas Safety Certificates',
  'Underfloor Heating',
  'Toilet & Tap Repairs',
  'Water Heater Installation'
];
